import { ListingData, useListingData } from "~/context/ListingPageDataContext";

import { useBookListingContext } from "./BookListingContext";

const useBookListingPriceData = () => {
  const { estimate, quote } = useBookListingContext();
  const { data: listingData = {} as ListingData } = useListingData();
  const shouldUseEstimate = !!(!quote && estimate);
  const payAtVenueTotal =
    quote?.masterContract?.calculations?.guest?.pay_at_venue
      ?.guest_payment_amount;
  const total =
    (shouldUseEstimate
      ? estimate?.total
      : (payAtVenueTotal ?? quote?.guestPaymentDetails?.subtotal_remaining)) ??
    0;
  const currency = listingData.listingCurrency;
  const country = listingData.listingCountry;

  return {
    total,
    currency,
    country,
  };
};

export { useBookListingPriceData };
